import { Routes } from '@angular/router';

import { auditorSpedRoutes } from '../apps/app-auditor-sped/app.routes';
import { notaFacilRoutes } from '../apps/app-nota-facil/app.routes';
import { AuthGuard } from './guard/auth/auth.guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'inicio',
    pathMatch: 'full'
  },
  {
    path: 'inicio',
    title: 'ITC Digital',
    loadComponent: () =>
      import('./components/landing-page/landing-page.component').then(m => m.LandingPageComponent)
  },
  {
    path: 'servicos',
    title: 'Serviços | ITC Digital',
    loadComponent: () =>
      import('./components/services-page/services-page.component').then(m => m.ServicesPageComponent),
    canActivate: [AuthGuard]
  },
  {
    path: 'guia',
    title: 'Guia de estilo | ITC Digital',
    loadComponent: () =>
      import('./components/shared/material-style-guide/material-style-guide.component').then(m => m.MaterialStyleGuideComponent),
    canActivate: [AuthGuard]
  },
  {
    path: 'app',
    children: [
      {
        path: 'guia',
        title: 'Guia | ITC Digital',
        loadComponent: () =>
          import('../apps/shared/app-guide/app-guide.component').then(m => m.AppGuideComponent),
        canActivate: [AuthGuard],
      },
      ...notaFacilRoutes,
      ...auditorSpedRoutes,
    ]
  },
  {
    path: '**',
    redirectTo: 'inicio',
    pathMatch: 'full'
  }
];